// =============================================
// SERVICE: Autenticação do Motorista PWA
// =============================================

import { Config } from './config';

const MOTORISTA_TOKEN_KEY = 'motorista_token';
const MOTORISTA_USER_KEY = 'motorista_user';

export function getMotoristaToken(): string | null {
  return localStorage.getItem(MOTORISTA_TOKEN_KEY);
}

export function getMotoristaUser(): any | null {
  try {
    const raw = localStorage.getItem(MOTORISTA_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function isMotoristaLoggedIn(): boolean {
  return !!getMotoristaToken();
}

export function logoutMotorista(): void {
  localStorage.removeItem(MOTORISTA_TOKEN_KEY);
  localStorage.removeItem(MOTORISTA_USER_KEY);
}

export async function loginMotorista(cpf: string, pin: string, slug?: string): Promise<{ success: boolean; message?: string; data?: any }> {
  try {
    const response = await fetch(`${Config.API_BASE_URL}/motorista/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cpf, pin, slug })
    });

    const result = await response.json();

    if (result.success && result.data) {
      localStorage.setItem(MOTORISTA_TOKEN_KEY, result.data.token);
      localStorage.setItem(MOTORISTA_USER_KEY, JSON.stringify(result.data.motorista));
      return { success: true, data: result.data.motorista };
    }

    return { success: false, message: result.message || 'Erro no login' };
  } catch (error) {
    return { success: false, message: 'Erro de conexao. Verifique sua internet.' };
  }
}

export async function fetchMotoristaApi(endpoint: string, options: RequestInit = {}): Promise<any> {
  const token = getMotoristaToken();
  const response = await fetch(`${Config.API_BASE_URL}/motorista${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers
    }
  });
  return response.json();
}
